<kt-portlet>
    <kt-portlet-header [sticky]="true" [title]="getComponentTitle()" [class]="'kt-portlet-head--lg'"
        [tooltipTitle]="'TOOLTIP.INSPECTION.FORM.TITLE' | translate"
        [tooltipDesc]="'TOOLTIP.INSPECTION.FORM.DESCRIPTION' | translate">
        <ng-container ktPortletTools>
            <a href="javascript:;" (click)="back()" class="btn mr-2" mat-raised-button
                matTooltip="Back to ToE dashboard">
                <mat-icon>arrow_back</mat-icon>
                <span class="kt-hidden-mobile">Close</span>
            </a>
            <a *ngIf="!readonly" href="javascript:;" class="btn btn-success mr-2" color="warn"
                style="background-color: orange !important;" (click)="onSubmit(false)" mat-raised-button
                matTooltip="Save to Draft">
                <span class="kt-hidden-mobile">Save draft</span>
            </a>
            <a *ngIf="!readonly" href="javascript:;" mat-raised-button class="btn btn-success mr-2" color="submit"
                (click)="onSubmit(true)" matTooltip="Save to Validate">
                <span class="kt-hidden-mobile">Validate</span>
            </a>
        </ng-container>
    </kt-portlet-header>

    <kt-portlet-body>
        <div class="card-body pt-0" *ngIf="isLoaded">
            <form [formGroup]="formGroup">
                <kt-form-tab-header [headers]="formTabHeaders$|async" (tabChange)="onTabChange($event)">
                </kt-form-tab-header>
                <!-- <kt-tab-header
                    [headerLabels]="tabHeaders"
                    [selectedTabChange]="selectedtabchange$"
                    (tabChange)="onTabChange($event)">
                </kt-tab-header> -->
                <mat-tab-group class="invinsible-tabs" [(selectedIndex)]="selectedTab"
                    (selecetedTabChange)="onTabChanged($event)">
                    <mat-tab>
                        <ng-container *ngIf="assetClass.top_property_type_id != propertyTypes.Land">
                            <kt-location [locationData]="assetClassDetail.locationData"
                                [assetClassTypeId]="assetClass.type_id"
                                [selectedBuildingId]="assetClassDetail.buildingInfo?.infoSection?.building_id"
                                [isSavedBefore]="isSavedBefore" (markerChange)="onMarkerChange($event)"
                                (buildingSelected)="onBuildingSelected($event)"
                                (timezoneChange)="onTimezoneChange($event)"
                                (formStateChange)="handleLocationFormStateChange($event)"></kt-location>
                        </ng-container>
                        <ng-container *ngIf="assetClass.top_property_type_id == propertyTypes.Land">
                            <ng-container *ngIf="landLocationData$|async as locationData">
                                <kt-land-map [points]="points$|async" [centerLat]="centerLat" [centerLng]="centerLng"
                                    [locationData]="locationData" [staticUnit]="2" [staticUnitLengthName]="'M'"
                                    [staticUnitName]="'sqm'"
                                    [landAreaComponentListSubject]="landAreaComponentListSubject"
                                    [landAreaSubject]="landAreaSubject"
                                    (sizeChange)="onLandSizesChange($event)"></kt-land-map>
                            </ng-container>
                        </ng-container>
                        <app-parcel-identification
                            *ngIf="assetClass.type_id != 5 && assetClass.type_id != 1 && assetClass.type_id != 3 && assetClass.top_property_type_id != propertyTypes.Land"
                            [form]="formGroup.controls.parcel_identification" [centerLat]="centerLat"
                            [centerLng]="centerLng" [marker]="markerInfo" [coordinatePoints]="coordinatePoints$|async"
                            [landAreas]="landAreas$|async" [defaultUnitMeasurementId]="staticUnit"
                            (coordinatePointsChange)="onCoordinatePointsChange($event)"
                            (landAreasChange)="onLandAreasChange($event)"
                            [unitOfAreaMeasurement]="unitOfAreaMeasurementId$|async"
                            ></app-parcel-identification>

                        <kt-building-form
                            *ngIf="assetClass.type_id == 5 || assetClass.type_id == 1 || assetClass.type_id == 3 || (assetClass.type_id ==2 && showBuilding)"
                            [(centerLat)]="centerLat" [(centerLng)]="centerLng" (centerChange)="onCenterChange($event)"
                            (picChange)="buildingPicChange($event)"
                            [buildingPictures]="assetClassDetail.building.pictures"
                            [buildingPicturePath]="assetClassDetail.building.picture" [isComplexForm]="true"
                            [acBuilding]="assetClassDetail.buildingInfo" [building$]="building$"
                            [parent]="'Inspection'"
                            [unitOfAreaMeasurement]="unitOfAreaMeasurementId$|async"
                            >
                        </kt-building-form>

                    </mat-tab>
                    <mat-tab>
                        <ng-container *ngIf="assetClass.top_property_type_id == propertyTypes.Land">
                            <div class="form-group row section-margin-top-60 tag-custom-padding-16_25">
                                <kt-land-use class="col-12" [landUseSubject]="landUseSubject"
                                    [buildingsSubject]="buildingsSubject">
                                </kt-land-use>
                            </div>

                            <div class="form-group row section-margin-top-60">
                                <kt-lp-building-tab
                                    *ngIf="buildingsSubject.value.length > 0 && assetClass.top_property_type_id === propertyTypes.Land"
                                    class="col-md-12" [(buildingsSubject)]="buildingsSubject">
                                </kt-lp-building-tab>
                            </div>

                        </ng-container>
                        <ng-container *ngIf="assetClass.top_property_type_id != propertyTypes.Land">
                            <kt-about-property [inputData]="aboutPropertyData" [propertySubTypeID]="assetClass.type_id"
                                [accommodation]="accommodationData" [isSavedBefore]="isSavedBefore"
                                (roomChange)="onRoomChanged($event)" (floorChanged)="onFloorChanged($event)"
                                (subTypeCategoryChanged)="onSubTypeCategoryChange($event)"
                                (formStateChange)="handleAboutFormStateChange($event)"
                                (buildingNumberChange)="onBuildingNumberChange($event)"></kt-about-property>
                        </ng-container>

                        <div class="form-group kt-form__group row section-margin-top-60"
                            *ngIf="assetClass.type_id == 7 || assetClass.type_id == 11 || assetClass.type_id == 17 || (assetClass.type_id == 2 && !showBuilding) || assetClass.top_property_type_id == propertyTypes.Land">
                            <div class="col-lg-12 kt-margin-bottom-20-mobile">
                                <h5 class="my-3 text-mad text-uppercase">Services and Infrastructures </h5>
                                <hr class="active">
                            </div>
                            <div class="col-lg-12">
                                <kt-services-and-infrastructures [propertySubTypeID]="assetClass.type_id"
                                    [isComplexForm]="true"
                                    [serviceAndInfraData]="assetClassDetail.serviceAndInfraData"></kt-services-and-infrastructures>
                            </div>
                        </div>

                        <div class="form-group kt-form__group row section-margin-top-60"
                            *ngIf="assetClass.type_id != 5 && assetClass.type_id != 2 && assetClass.type_id != 1 && assetClass.type_id != 3 && assetClass.top_property_type_id != propertyTypes.Land">
                            <div class="col-lg-12 kt-margin-bottom-20-mobile">
                                <h5 class="my-3 text-mad text-uppercase">External Aspect</h5>
                                <hr class="active">
                            </div>
                            <div class="col-lg-12">
                                <kt-external-aspects [propertySubTypeID]="assetClass.type_id"
                                    [externalAspectData]="assetClassDetail.externalAspectData"
                                    [isSavedBefore]="isSavedBefore"
                                    (formStateChange)="handleExternalAspect($event)"></kt-external-aspects>
                            </div>
                        </div>

                        <div class="form-group kt-form__group row section-margin-top-60"
                            *ngIf="assetClass.type_id != 2 && assetClass.top_property_type_id != propertyTypes.Land">
                            <div class="col-lg-12 kt-margin-bottom-20-mobile">
                                <h5 class="my-3 text-mad text-uppercase">Internal Aspect</h5>
                                <hr class="active">
                            </div>
                            <div class="col-lg-12">
                                <kt-internal-aspects [propertySubTypeID]="assetClass.type_id"
                                    [internalAspectData]="assetClassDetail.internalAspectData"
                                    [isSavedBefore]="isSavedBefore"
                                    (formStateChange)="handleInternalAspect($event)"></kt-internal-aspects>
                            </div>
                        </div>

                        <div class="form-group kt-form__group row section-margin-top-60"
                            *ngIf="assetClass.type_id != 2 && assetClass.top_property_type_id != propertyTypes.Land">
                            <div class="col-lg-12 kt-margin-bottom-20-mobile">
                                <h5 class="my-3 text-mad text-uppercase">Grounds</h5>
                                <hr class="active">
                            </div>
                            <div class="col-lg-12">
                                <kt-ac-grounds [parent]="'inspection'" [isComplexForm]="true"
                                    [propertySubTypeID]="assetClass.type_id" [initData]="assetClassDetail.grounds"
                                    [isSavedBefore]="isSavedBefore"
                                    (formStateChange)="handleGround($event)"></kt-ac-grounds>
                            </div>
                        </div>

                        <ng-container *ngIf="assetClass.top_property_type_id != propertyTypes.Land">
                            <kt-inspection-size-measurements
                                [isInstructedToMeasure]="assetClass.instructed_to_measure == 1"
                                [propertySubTypeID]="assetClass.type_id" [acSizeData]="acSizeInfo"
                                [sizeData]="acSizeInfo" [measurementData]="acMeasurementData"
                                [assetClassID]="assetClass.id" [readonly]="readonly" [sizesSubject]="sizesSubject"
                                [roomChange$]="roomChange$" (staticUnitChange)="onStaticUnitChange($event)"
                                (changeComponents)="onChangeComponents($event)"
                                (changeStandardMeasurement)="onChangeStandardMeasurement($event)">
                            </kt-inspection-size-measurements>
                        </ng-container>

                        <ng-container *ngIf="numberOfBuildings$|async">
                            <div class="form-group kt-form__group row section-margin-top-60">
                                <div class="col-lg-12 kt-margin-bottom-20-mobile">
                                    <h5 class="my-3 text-mad text-uppercase">
                                        Ancillary Buildings
                                    </h5>
                                    <hr class="active">
                                </div>

                                <div class="col-lg-12">
                                    <mat-tab-group>
                                        <ng-container
                                            *ngFor="let building of (buildings$|async); let i = index; trackBy: identity">
                                            <mat-tab>
                                                <ng-template mat-tab-label>
                                                    {{ i + 1}} - Building {{ i + 1}}
                                                </ng-template>
                                                <app-ancillary-building-form [building]="building"
                                                    [mainWallOptions]="mainwalls"
                                                    [externalFacadeOptions]="externalFacades"
                                                    [roofCoveringOptions]="roofCoverings"
                                                    [unitAreaMeasurementOptions]="unitAreaMeasurements"
                                                    (buildingChange)="onBuildingChange($event)"></app-ancillary-building-form>
                                            </mat-tab>
                                        </ng-container>
                                    </mat-tab-group>
                                </div>
                            </div>
                        </ng-container>

                        <div class="form-group kt-form__group row section-margin-top-60">
                            <div class="col-lg-12 kt-margin-bottom-20-mobile">
                                <h5 class="my-3 text-mad text-uppercase">
                                    Investigation Process Review
                                </h5>
                            </div>
                            <div class="col-lg-12">
                        <ng-container *ngIf="scopes$|async as vm">
                            <div class="row mt-10">
                                <div class="col-6">
                                    <div class="row">
                                        <ng-container *ngFor="let scope of vm.column_1">
                                            <div class="col-12">
                                                <div class="font-weight-bold">
                                                    {{ scope.name }}
                                                </div>
                                                <div class="w-100 d-flex align-items-center">
                                                    <mat-form-field class="mat-form-field-fluid mr-4" style="flex-grow: 1">
                                                        <mat-select [value]="scope.value" (selectionChange)="onScopeSelected(scope.defaultName, $event)">
                                                            <mat-option [value]="''">-</mat-option>
                                                            <mat-option *ngFor="let option of scope.options" [value]="option.defaultName">
                                                                {{ option.name }}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                    <div *ngIf="scope.option_description" class="d-flex align-items-center">
                                                        <button mat-icon-button type="button" color="primary" container="body" [ngbPopover]="scope.option_description">
                                                            <mat-icon>
                                                                remove_red_eye
                                                            </mat-icon>
                                                        </button>
                                                        <button mat-icon-button type="button" color="primary" (click)="onScopeCommentAdd(scope)">
                                                            <mat-icon>
                                                                edit
                                                            </mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="row">
                                        <ng-container *ngFor="let scope of vm.column_2">
                                            <div class="col-12">
                                                <div class="font-weight-bold">
                                                    {{ scope.name }}
                                                </div>
                                                <div class="w-100 d-flex align-items-center">
                                                    <mat-form-field class="mat-form-field-fluid mr-4" style="flex-grow: 1">
                                                        <mat-select [value]="scope.value" (selectionChange)="onScopeSelected(scope.defaultName, $event)">
                                                            <mat-option [value]="''">-</mat-option>
                                                            <mat-option *ngFor="let option of scope.options" [value]="option.defaultName">
                                                                {{ option.name }}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                    <div *ngIf="scope.option_description" class="d-flex align-items-center">
                                                        <button mat-icon-button type="button" color="primary" container="body" [ngbPopover]="scope.option_description">
                                                            <mat-icon>
                                                                remove_red_eye
                                                            </mat-icon>
                                                        </button>
                                                        <button mat-icon-button type="button" color="primary" (click)="onScopeCommentAdd(scope)">
                                                            <mat-icon>
                                                                edit
                                                            </mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab>
                        <kt-esg-indicators formType="inspection" [value]="assetClassDetail.esgIndicator"
                            [systemOfMeasurement]="acSizeInfo.toeUnitOfMeasurementID" />
                    </mat-tab>
                    <mat-tab>
                        <!-- <ng-container *ngIf="ipmsComponents$|async as components">
                            <ng-container *ngIf="components.length > 0 && (assetClass.type_of_inspection == 3 || assetClass.type_of_inspection == 4) && standardMeasurementId === 48">
                                <kt-condition-rating
                                    [components]="components"
                                    [conditionRatings]="conditionRatings$|async"
                                    (changeConditionRatings)="onChangeConditionRatings($event)">
                                </kt-condition-rating>
                            </ng-container>
                        </ng-container> -->
                        <ng-container
                            *ngIf="(assetClass.type_of_inspection == 3 || assetClass.type_of_inspection == 4) && showConditionRating">
                            <kt-inspection-condition-ratings class="section-margin-top-60" *ngIf="hasComponents">
                            </kt-inspection-condition-ratings>
                            <kt-inspection-condition-ratings-upload class="section-margin-top-60" *ngIf="!hasComponents"
                                [files]="assetClassDetail.condition_rating_documents">
                            </kt-inspection-condition-ratings-upload>
                        </ng-container>

                        <div class="col-md-12 mt-4">
                            <div class="mb-2">
                                <mat-label>Would you like to record potential environmental issues for this
                                    property?</mat-label>
                                <mat-radio-group class="ml-4" formControlName="record_potential_env_issues">
                                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                                    <mat-radio-button [value]="false">No</mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>

                        <kt-inspection-observation class="section-margin-top-60" *ngIf="recordPotentialEnvIssue"
                            [propertyTypeID]="assetClass.top_property_type_id"
                            [recordInfoType]="assetClassDetail.record_info_type"
                            [observationChecklist]="assetClassDetail.observation_checklist"
                            [observationDocuments]="assetClassDetail.observation_documents">
                        </kt-inspection-observation>
                    </mat-tab>
                    <mat-tab>
                        <kt-inspection-pictures [picture]="assetClassDetail.picture"
                            [pictures]="assetClassDetail.ac_pictures" [readonly]="readonly"
                            [propertyTypeID]="assetClass.top_property_type_id"
                            [conditionRatingDropdownValues$]="conditionRatingDropdownValues$"
                            [conditionRatingRelated$]="conditionRatingRelated$"></kt-inspection-pictures>

                        <kt-inspection-building-pictures
                            *ngIf="assetClass.type_id == 1 || assetClass.type_id == 3 || assetClass.type_id == 5 || (assetClass.type_id == 2 && showBuilding)"
                            [buildingPictures]="building_pictures" [buildingPicturePath]="building_picture"
                            [hasFormErrors]="hasFormError"
                            [buildingId]="assetClassDetail.building.building_id"></kt-inspection-building-pictures>

                        <div class="form-group row section-margin-top-60 tag-custom-padding-16_25">
                            <div class="col-md-12 kt-margin-bottom-20-mobile">
                                <h5 class="my-3 text-mad text-uppercase">Property Videos</h5>
                                <hr class="active">
                            </div>
                            <app-upload class="col-md-12" [videos]="assetClassDetail.videos"
                                [readonly]="readonly"></app-upload>
                            <div class="col-md-12 kt-margin-bottom-20-mobile">
                                <mat-error class="tag-custom-error"
                                    *ngIf="hasFormError && videoTitleRequiredError$|async">
                                    Video should have a <strong>Title</strong>
                                </mat-error>
                            </div>
                        </div>

                        <div class="form-group row section-margin-top-60 tag-custom-padding-16_25">
                            <div class="col-md-12 kt-margin-bottom-20-mobile">
                                <h5 class="my-3 text-mad text-uppercase">Matterport Link</h5>
                                <hr class="active">
                            </div>
                            <kt-link-list class="col-md-12" [links]="assetClassDetail.links" [linkType]="1"
                                [readOnly]="readonly">
                            </kt-link-list>
                        </div>
                    </mat-tab>
                </mat-tab-group>





            </form>
        </div>
    </kt-portlet-body>
</kt-portlet>